import { css } from '@Root/lib/lit-3form-block';

export const styles = [
  css`
    .clark-layout {
      grid-template-rows:
        var(--block-top-padding)
        minmax(0, auto)
        minmax(0, auto)
        var(--block-bottom-padding)
        [last-line];
      max-width: 100%;
      align-items: end;
    }

    /* The block sets align-items on the grid, which would collapse the shared
       rule inside its grid area; stretch it so the border-bottom lands at the
       block's bottom. */
    .horizontal-rule {
      align-self: stretch;
    }

    h2 {
      padding-bottom: calc(20rem / var(--default-rem-px-count));
    }

    /* Image titles are small bold labels, not headings, so they take the
       label-small tokens rather than the full-size h3 default. */
    h3 {
      font-size: var(--fs-label-small);
      line-height: var(--lh-label-small);
      letter-spacing: var(--ls-label-small);
      padding-top: calc(14rem / var(--default-rem-px-count));
    }

    cta-text {
      padding-top: calc(14rem / var(--default-rem-px-count));
    }

    img {
      max-width: 100%;
    }

    .header {
      grid-column: 2 / 8;
      grid-row: 2;
      padding-bottom: calc(40rem / var(--default-rem-px-count));
    }

    .images {
      grid-column: 2 / 8;
      grid-row: 3;
      display: flex;
      flex-wrap: wrap;
      gap: calc(40rem / var(--default-rem-px-count));
    }

    /* Cards are driver-card elements; spacing is padding-based (gap zeroed)
       and images sit natural-size, centered in a bordered aspect box. */
    .image-wrapper {
      width: 100%;
      --driver-card-gap: 0;
      --driver-card-image-width: auto;
      --driver-card-image-fit: initial;
    }

    .image-wrapper::part(image) {
      width: 100%;
      aspect-ratio: 3 / 2;
      border: 0.5px solid var(--block-text-color, #222222);
      display: flex;
      justify-content: center;
      align-items: center;
    }

    /* Card titles are small bold labels: label-small tokens at medium. */
    .image-wrapper::part(title) {
      font-size: var(--fs-label-small);
      line-height: var(--lh-label-small);
      letter-spacing: var(--ls-label-small);
      font-weight: var(--fw-medium);
      padding-top: calc(14rem / var(--default-rem-px-count));
    }

    .image-wrapper::part(description) {
      padding-top: calc(14rem / var(--default-rem-px-count));
      font-size: var(--fs-caption);
      line-height: var(--lh-caption);
      letter-spacing: var(--ls-caption);
    }

    .image {
      width: 100%;
      aspect-ratio: 3 / 2;
      border: 0.5px solid var(--block-text-color, #222222);
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .text-sections-wrapper {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: space-between;
    }

    .text-section {
      padding-top: calc(14rem / var(--default-rem-px-count));
      font-size: var(--fs-body-small);
      line-height: var(--lh-body-small);
      letter-spacing: var(--ls-body-small);
    }

    @media (min-width: 600px) {
      .clark-layout {
        grid-template-rows:
          var(--block-top-padding)
          minmax(0, auto)
          var(--block-bottom-padding)
          [last-line];
        align-items: start;
      }

      h2 {
        padding-bottom: calc(40rem / var(--default-rem-px-count));
      }

      .image-wrapper::part(title) {
        padding-top: calc(20rem / var(--default-rem-px-count));
      }

      /* Captions flip to body-small on desktop, matching image-caption. */
      .image-wrapper::part(description) {
        font-size: var(--fs-body-small);
        line-height: var(--lh-body-small);
        letter-spacing: var(--ls-body-small);
      }

      cta-text {
        padding-top: calc(20rem / var(--default-rem-px-count));
      }

      .header {
        grid-column: 2 / 5;
        grid-row: 2;
      }

      .images {
        grid-column: 6 / 12;
        grid-row: 2;
        gap: calc(2 * var(--between-column-padding))
          var(--between-column-padding);
      }

      .image,
      .image-wrapper::part(image) {
        aspect-ratio: 1 / 1;
      }

      .image-wrapper {
        width: calc(50% - calc(var(--between-column-padding) / 2));
      }
    }
  `,
];
